export default __webpack_public_path__ + "static/media/misc-closetA-1440w.ea0a795e.avif";